export default __webpack_public_path__ + "static/media/favicon.efe732a1.ico";